'use strict';

angular.module('app.helpers', [])
// directive implements select2 
// Usage
/*
 * <t3bs-select2 class="form-control"
 *  select2-value="id"
 *  select2-display="name"
 *  select2-model="employee.contract_type"
 *  source="contractTypes">
 * </t3bs-select2>
 */
.directive('t3bsSelect2', function ($timeout) {
  return {
    restrict: 'E',
    scope: {
      select2Model: '=',
      select2Callback: '=',
      source: '='
    },
    transclude: true,
    template: '<select class="t3bsSelect2" style="width: 100%">' + '<option ng-repeat="c in source" value="{{ c[idv] }}">{{ c[valuev] }}</option>' + '</select>',
    replace: true,
    link: function link(scope, element, attrs) {
      scope.idv = attrs.select2Value || 'id';
      scope.valuev = attrs.select2Display || 'name';

      //init
      $timeout(function () {
        $(element).select2({ theme: 'bootstrap' });
        element.select2Initialized = true;
        //watchers
        scope.$watch('source', reload);
        scope.$watch('select2Model', updateSelection);
      });

      function reload() {
        if (!element.select2Initialized) return;
        $timeout(function () {
          $(element).trigger('change');
          updateSelection();
        });
      };

      function updateSelection() {
        if (!scope.select2Model) {
          checkModel();
          return;
        }

        if (element.idOpt == scope.select2Model[scope.idv]) return;

        $(element).val(scope.select2Model[scope.idv]).trigger("change");
      }

      //events listener of select
      $(element).on("select2:select", changeModel);
      function changeModel(e, id) {
        element.idOpt = e.params.data[scope.idv] || e.params.data['id'];
        $timeout(function () {
          scope.select2Model = search(element.idOpt, scope.source);
          if (scope.select2Callback) {
            scope.select2Callback(scope.select2Model);
          }
        });
      };

      //helpers
      function search(indx, list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i][scope.idv] == indx) {
            return list[i];
          }
        }
      };

      function checkModel() {
        if (!scope.source) return;
        if (scope.source.length) {
          if (!scope.select2Model) {
            scope.select2Model = scope.source[0];
          }
        }
      };
    }
  };
});
'use strict';

angular.module('app.helpers').directive('t3bDropzone', function () {
  return {
    template: function template(tElt, tAttrs) {
      return ' <div class="uploader-inline" id="dropzone"> \
                <input type="file" multiple="true" name="file" style="display:none"> \
                <ul class="list-files" ng-show="filesModel.length"> \
                  <li class="filePrev" ng-repeat="file in filesModel" > \
                    <div class="head-file"> \
                      <img ng-src="{{ getImage(file) }}" class="filePrev" alt=""> \
                      <small class="size"><strong>{{ calcSize(file.size) }}</strong></small> \
                    </div> \
                    <div class="footer-file"> \
                      <button ng-click="$event.preventDefault(); $event.stopPropagation(); deleteFile(file, $index)" \
                        class="btn btn-flat btn-xs btn-danger flat-btn"> \
                        <i class="fa fa-times"></i> \
                      </button> \
                    </div> \
                    <small class="truncate namefile" ng-if="file.name">{{ file.name }}</small> \
                    <small class="truncate namefile" ng-if="!file.name"> \
                      <a href="javascript:void(0);"  \
                        google-view="file" \
                        google-view-type="document" \
                        class="mailbox-attachment-name"> \
                      <i class="fa fa-paperclip"></i>  \
                      {{ getName(file.file_url)  }} \
                      </a> \
                    </small> \
                  </li> \
                </ul> \
                <div class="uploader-inline-content" ng-show="!filesModel.length"> \
                  <div class="upload-ui"> \
                    <h2 class="instructions">Arrastre ficheros a cualquier lugar para cargarlos</h2> \
                    <p class="instructions">o</p> \
                    <button class="btn btn-flat bg-purple"> \
                      <i class="fa fa-upload"></i>  \
                      Seleccionar archivos \
                    </button> \
                  </div> \
                  <div class="rules"> \
                    <p>Tamaño máximo del fichero: 20 MB.</p> \
                  </div> \
                </div> \
              </div>';
    },
    scope: {
      filesModel: '='
    },
    link: function link(scope, element, attrs) {
      var $input = element[0].querySelector('input');
      var $dropzone = element[0].querySelector('#dropzone');

      function triggerCallback(e) {
        console.log(e);
        var files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        for (var i = 0; i < files.length; i++) {
          scope.filesModel.push(files.item(i));
          scope.$apply();
        }
        console.log(scope.filesModel);
      };

      scope.deleteFile = function (file, ind) {
        scope.filesModel.splice(ind, 1);
        console.log(file, ind);
      };

      scope.calcSize = function (bytes) {
        if (bytes == undefined) return '';
        if (bytes == 0) return '0 Byte';
        var k = 1000; // or 1024 for binary
        var dm = 2;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      };

      scope.getName = function (url) {
        return url.split('/').pop();
      };

      scope.getImage = function (file) {
        var url = file.name || file.file_url;
        var ext = getExtension(url);
        switch (ext) {
          case 'xls':
          case 'xlsx':
            return 'http://i64.tinypic.com/f4mxi8.jpg';
          case 'doc':
          case 'docx':
            return 'http://i64.tinypic.com/106h3x4.jpg';
          case 'pdf':
            return 'http://i67.tinypic.com/aviv6t.jpg';
          case 'jpeg':
          case 'jpg':
          case 'png':
          case 'gif':
            return 'http://i66.tinypic.com/2d6sbnt.jpg';
          default:
            return 'http://i66.tinypic.com/2anwpw.jpg';
        }
      };

      function getExtension(filename) {
        return filename.split('.').pop();
      };

      $input.addEventListener('change', triggerCallback);

      var show = false;
      $dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();e.stopPropagation();

        show = true;
        $dropzone.classList.add('dragover');
      });
      $dropzone.addEventListener('dragleave', function (e) {
        e.preventDefault();e.stopPropagation();

        show = false;
        setTimeout(function () {
          if (!show) {
            $dropzone.classList.remove('dragover');
          }
        }, 200);
      });
      $dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $dropzone.classList.remove('dragover');
        triggerCallback(e);
      });

      $dropzone.addEventListener('click', function () {
        $input.value = null;
        $input.click();
      });
    }
  };
});
'use strict';

angular.module('app.statistics', []).service('GraficsService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.url = CONFIG.API_URL;

  this.getAll = function (id, callback) {
    return $http.get(this.url + 'statistics/' + id).then(callback);
  };
  this.getAllNotifications = function (id, callback, error, noblock) {

    return $http.get(this.url + 'notification/' + id).then(callback, error);
  };
}]);
'use strict';

angular.module('app.statistics').controller('GraficCtrl', ['$scope', 'GraficsService', 'CONFIG', '$routeParams', function ($scope, GraficsService, CONFIG, $routeParams) {

  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  var idEntidad = $scope.$parent.user.user.id_entidad;

  $scope.user = $scope.$parent.user.user;

  // $scope.counter = $scope.$parent.counter;
  // GraficsService.getAllNotifications(idEntidad, (response) =>{
  //   $scope.notifications = response.data;
  //   $scope.counter = $scope.notifications.length ;

  // });

  GraficsService.getAll(idEntidad, function (response) {
    $scope.grafics = response.data;
    console.log($scope.grafics);

    var documentos_vencidos = $scope.grafics[0].documentos_vencidos;
    var documentos_no_vencidos = $scope.grafics[0].documentos_noVencidos;
    var documentos_null = $scope.grafics[0].documentos_null;
    donut_documents_plate(documentos_vencidos, documentos_null, documentos_no_vencidos);

    var licenses_vencidos = $scope.grafics[0].licencias_vencidas;
    var licenses_no_vencidos = $scope.grafics[0].licencias_habilitadas;
    var licenses_nulos = $scope.grafics[0].licencias_anuladas;

    donut_documents_licenses(licenses_vencidos, licenses_no_vencidos, licenses_nulos);
  });

  //torta documentos placas

  //let total_documentosP =  $scope.grafics[0].documentos_habilitados;

  //let documentos_vencidos =  $scope.grafics[0].documentos_vencidos;
  //
  //
  //
  function donut_documents_plate(vencidos, nulos, no_vencidos) {
    console.log(vencidos);
    console.log(nulos);
    console.log(no_vencidos);
    var donutData = [{ label: "Vencidos", data: vencidos, color: "#AF2525" }, { label: "Nulos", data: nulos, color: "#0073b7" }, { label: "No vencidos", data: no_vencidos, color: "#00a65a" }];
    $.plot("#donut-chart", donutData, {
      series: {
        pie: {
          show: true,
          radius: 1,
          innerRadius: 0.5,
          label: {
            show: true,
            radius: 2 / 3,
            formatter: labelFormatter,
            threshold: 0.1
          }

        }
      },
      legend: {
        show: false
      }
    });
  }

  function donut_documents_licenses(vencidas, no_vencidas, nulas) {
    var donutData = [{ label: "Vencidas", data: vencidas, color: "#AF2525" }, { label: "No vencidas", data: no_vencidas, color: "#00a65a" }, { label: "Nulas", data: nulas, color: "#1D6590" }];
    $.plot("#donut-chart-licenses", donutData, {
      series: {
        pie: {
          show: true,
          radius: 1,
          innerRadius: 0.5,
          label: {
            show: true,
            radius: 2 / 3,
            formatter: labelFormatter,
            threshold: 0.1
          }

        }
      },
      legend: {
        show: false
      }
    });
  }

  function labelFormatter(label, series) {
    return '<div style="font-size:13px; text-align:center; padding:2px; color: #fff; font-weight: 600;">' + label + "<br>" + Math.round(series.percent) + "%</div>";
  }
}]);
'use strict';

angular.module('app.subpoena', []).controller('SubpoenaCtrl', ['$scope', 'HomeService', 'CONFIG', '$routeParams', function ($scope, HomeService, CONFIG, $routeParams) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  var idEntidad = $scope.$parent.user.user.id_entidad;

  $scope.user = $scope.$parent.user.user;

  // $scope.counter = $scope.$parent.counter;
  // GraficsService.getAllNotifications(idEntidad, (response) =>{
  //   $scope.notifications = response.data;
  //   $scope.counter = $scope.notifications.length ;

  // });

  //torta documentos placas

  //let total_documentosP =  $scope.grafics[0].documentos_habilitados;

  //let documentos_vencidos =  $scope.grafics[0].documentos_vencidos;
  //
  //
  //
  $scope.scraper = function (cedula) {

    console.log("scraper!");
    HomeService.get_scraper(cedula, function (response) {
      $scope.comparendos = response.data.results;

      $scope.vacio = false;
      if ($scope.comparendos.length == 0) {
        $scope.vacio = true;
      } else {

        var count = Object.keys($scope.comparendos[0]).length;
      }
      if (count == 11) {
        console.log('asd');
        $scope.comp = false;
      }
      if (count == 12) {
        $scope.comp = true;
      }

      console.warn($scope.comparendos);

      // $scope.deliberatelyTrustDangerousSnippet = function() {
      //   return $sce.trustAsHtml($scope.html);
      // };
    });
  };
}]);
'use strict';

angular.module('app.users', []).service('UsersService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.url = CONFIG.API_URL;
  this.currentUser = null;

  this.getAll = function (id, callback) {
    return $http.get(this.url + 'licencias/' + id).then(callback);
  };
  this.getAllNotifications = function (id, callback, error, noblock) {
    console.log(id);

    return $http.get(this.url + 'notification/' + id).then(callback, error);
  };
  this.getAllCity = function (callback, error, noblock) {

    return $http.get(this.url + 'citys/').then(callback, error);
  };

  this.getSucursal = function (id, callback) {
    return $http.get(this.url + 'licencias/' + id + '/sucursales').then(callback);
  };

  this.get_delete_driver = function (id, empresa, callback) {
    return $http.get(this.url + 'licencias/anulada/' + id + '/' + empresa).then(callback);
  };

  this.get_one_driver = function (id, callback) {
    return $http.get(this.url + 'licencias-detalles/' + id).then(callback);
  };

  this.setCurrentUser = function (user) {
    this.currentUser = user;
  };
  this.edit = function (data, callback, error) {
    var conf = {
      url: this.url + 'licencias/editar/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };

    return $http(conf).then(callback, error);
  };

  this.update = function (data, callback, error) {
    var conf = {
      url: this.url + 'licencias/actualizar/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };

    return $http(conf).then(callback, error);
  };

  this.create_driver = function (data, callback, error) {

    var conf = {
      url: this.url + 'licencias/crear-conductor/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback, error);
  };
}]);
'use strict';

angular.module('app.users').controller('UsersCtrl', ['$scope', 'Notification', 'CONFIG', 'UsersService', '$location', 'DTOptionsBuilder', 'DTColumnBuilder', function ($scope, Notification, CONFIG, UsersService, $location, DTOptionsBuilder, DTColumnBuilder) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.users = [];
  $scope.itemsByPage = 5;

  $scope.user = $scope.$parent.user.user;

  $scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(10).withLanguage({
    "sSearch": "Buscar",
    "sLengthMenu": "Mostrar _MENU_ entradas",
    "sEmptyTable": "No hay  documentos que mostrar",
    "sInfo": "Mostrando _START_ a  _END_ de  _TOTAL_ entradas",
    "sZeroRecords": "No se encontraron resultados",
    "oPaginate": {
      "sNext": "Siguiente",
      "sPrevious": "Anterior"
    }
  }).withOption('responsive', true).withButtons([{
    extend: 'copy',

    text: 'Copiar',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'print',
    text: 'Imprimir',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'excel',
    text: 'Exportar a Excel ',
    exportOptions: {
      columns: [0, 1]
    }
  }]);

  console.log("%cDesarrollado por TRASMOVIL S.A.S", "; color: red; font-size: x-large");

  $(".sel").select2();
  var idEntidad = $scope.$parent.user.user.id_entidad;
  UsersService.getAll(idEntidad, function (response) {
    $scope.drivers = response.data;
    console.log($scope.drivers);
  });
  UsersService.getAllNotifications(idEntidad, function (response) {
    $scope.notifications = response.data;
    console.warn($scope.notifications);
    $scope.counter = $scope.notifications.length;
  });
  $scope.counter = $scope.$parent.counter;

  $scope.search = function () {

    // Write on keyup event of keyword input element
    $("#search").keyup(function () {

      var valu = this;
      // Show only matching TR, hide rest of them
      $.each($("#userTable tbody tr"), function () {
        if ($(this).text().toLowerCase().indexOf($(valu).val().toLowerCase()) === -1) $(this).hide();else $(this).show();
      });
    });
  };
  $scope.new_conduct = function () {
    $location.path('/new/');
  };
  $scope.edit_conduct = function (id) {
    console.log(id);

    $location.path('/edit/' + id);
  };
  $scope.renove_conduct = function (id) {
    $location.path('/renove/' + id);
  };

  $scope.detail_conduct = function (id) {
    console.log(id);
    $location.path('/detail/' + id);
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.delete_conduct = function (id) {
    var r = confirm("Una vez anulado no podrá modificar  esto. ¿Estas seguro que desea anular este documento?");

    if (r != true) {

      return;
    };

    console.log('entro');
    UsersService.get_delete_driver(id, idEntidad, function (response) {

      UsersService.getAll(idEntidad, function (response) {
        $scope.drivers = response.data;
        console.log($scope.drivers);
      });
      UsersService.getAllNotifications(idEntidad, function (response) {
        $scope.notifications = response.data;
        console.warn($scope.notifications);
        $scope.counter = $scope.notifications.length;
      });
    });
  };
}]);
'use strict';

angular.module('app.users').controller('RenoveCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', '$location', 'Notification', 'HomeService', function ($scope, CONFIG, UsersService, $routeParams, $location, Notification, HomeService) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  $scope.button_renove = false;

  $scope.user = $scope.$parent.user.user;
  var id_entidad = $scope.$parent.user.user.id_entidad;

  UsersService.get_one_driver($routeParams.id, function (response) {
    $scope.driver = response.data[0];
    // //Fecha de expedición
    // let expedicion = new Date($scope.driver.fecha_expedicion);
    // $scope.driver.fecha_expedicion = expedicion.setDate(expedicion.getDate() + 1);
    // $scope.driver.fecha_expedicion = new Date($scope.driver.fecha_expedicion);
    // //End fecha expedición

    // //Fecha de nacimiento 
    //  let nacimiento= new Date($scope.driver.fecha_nacimiento);
    //  $scope.driver.fecha_nacimiento = nacimiento.setDate(nacimiento.getDate() + 1);
    //  $scope.driver.fecha_nacimiento = new Date($scope.driver.fecha_nacimiento);
    // //End fecha de nacimiento

    // //Vigencia
    // let vigencia = new Date($scope.driver.vigencia);
    // $scope.driver.vigencia = vigencia.setDate(vigencia.getDate() + 1);
    // $scope.driver.vigencia = new Date($scope.driver.vigencia);
    // //End vigencia
    $scope.driver.fecha_nacimiento = '';
    $scope.driver.fecha_expedicion = '';
    $scope.driver.vigencia = '';
    $scope.driver.nombres = '';
    $scope.driver.apellidos = '';
    $scope.driver.cedula = '';
    $scope.driver.tipo_sangre = '';
    $scope.driver.licencia = '';
    $scope.driver.restricciones_conductor = '';
    $scope.driver.categoria_licencia = '';
    $scope.driver.direccion = '';
    $scope.driver.telefono = '';
    $scope.driver.celular = '';
    $scope.driver.correo = '';
    $scope.driver.ciudad = '';
  });

  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });
  UsersService.getAllCity(function (response) {
    $scope.ciudades = response.data;
  });
  console.warn($routeParams.id);

  //comparar fecha expedición
  $scope.compare_date_expe = function () {

    var expedicion = new Date($scope.driver_server.vigencia);
    var date_expire = expedicion.setDate(expedicion.getDate() + 1);

    date_expire = new Date(date_expire).getTime();

    //console.log(date_expire);
    // date_current = date_current.setDate($scope.driver.fecha_expedicion.getDate() + 1);
    //console.log(date_current);
    var date_current = $scope.driver.fecha_expedicion.getTime();

    if (date_expire >= date_current) {

      console.log('hoalaa');
      $scope.button_renove = false;

      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };

  //compara fechas vigentes  
  $scope.compare_date_vige = function () {

    var vigencia = new Date($scope.driver_server.vigencia);

    var date_vige = vigencia.setDate(vigencia.getDate());
    date_vige = new Date(date_vige).getTime();

    var date_current = $scope.driver.vigencia.getTime();

    if (date_vige >= date_current) {

      console.log('hoalaa');
      $scope.button_renove = false;

      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };
  //actualiza  la licencia 
  $scope.update_driver = function (data) {

    data.empresa = id_entidad;
    data.id = $scope.driver.id;
    console.log(data);

    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.update(fd, function (response) {
      Notification.success('Licencia renovada exitosamente');

      HomeService.getAllNotifications(id_entidad, function (response) {
        $scope.notifications = response.data;

        $scope.counter = $scope.notifications.length;

        $scope.$emit('notifications', $scope.counter);
      });

      $location.path('/licencias');
    });
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]);
'use strict';

angular.module('app.users').controller('NewCtrl', ['$scope', 'CONFIG', '$location', 'Notification', 'HomeService', 'UsersService', function ($scope, CONFIG, $location, Notification, HomeService, UsersService) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.continueForm = false;

  $scope.user = $scope.$parent.user.user;
  var id_entidad = $scope.$parent.user.user.id_entidad;

  // UsersService.getCiudad( (response)=>{
  //    $scope.municipios = response.data;
  //  })


  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });
  UsersService.getAllCity(function (response) {
    $scope.citys = response.data;
    console.log($scope.citys);
  });

  $scope.checkearComparendo = function (cedula) {

    console.log('scraper');
    HomeService.get_scraper(cedula, function (response) {
      $scope.comparendos = response.data.results;
    });
  };

  $scope.avaliable = function () {

    $scope.continueForm = true;
    console.log($scope.continueForm);
  };
  $scope.save_driver = function (data) {
    data.empresa = id_entidad;

    $scope.continueForm = false;

    console.warn(data);

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.create_driver(fd, function (response) {

      var res = response.data.error;

      var re = response.data;

      if (!res) {
        $scope.continueForm = true;

        Notification.success('Conductor ' + re + ' guardado correctamente');

        $scope.driver = {};

        angular.element("input[type='file']").val(null);

        $location.path('/licencias');
      } else {

        $scope.continueForm = true;
        Notification.error({ message: res, positionX: 'center' });
      };
    });
  };

  $scope.clear = function () {
    console.log('afsd');

    $scope.driver = {};

    angular.element("input[type='file']").val(null);
  };

  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
}]).directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      elem.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, elem[0].files[0]);
        });
      });
    }
  };
}]).directive('tooltip', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      $(element).hover(function () {
        // on mouseenter
        $(element).tooltip('show');
      }, function () {
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
}).directive('ng-blur', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      element.bind('blur', function () {
        scope.$apply(attrs.ngBlur);
      });
    }
  };
});
'use strict';

angular.module('app.users').controller('EditCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', '$location', 'Notification', function ($scope, CONFIG, UsersService, $routeParams, $location, Notification) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.user = $scope.$parent.user.user;
  var id_entidad = $scope.$parent.user.user.id_entidad;

  UsersService.get_one_driver($routeParams.id, function (response) {
    console.warn(response);
    $scope.driver = response.data[0];

    //Fecha de expedición
    var expedicion = new Date($scope.driver.fecha_expedicion);
    $scope.driver.fecha_expedicion = expedicion.setDate(expedicion.getDate() + 1);
    $scope.driver.fecha_expedicion = new Date($scope.driver.fecha_expedicion);
    //End fecha expedición

    //Fecha de nacimiento 
    var nacimiento = new Date($scope.driver.fecha_nacimiento);
    $scope.driver.fecha_nacimiento = nacimiento.setDate(nacimiento.getDate() + 1);
    $scope.driver.fecha_nacimiento = new Date($scope.driver.fecha_nacimiento);
    //End fecha de nacimiento

    //Vigencia
    var vigencia = new Date($scope.driver.vigencia);
    $scope.driver.vigencia = vigencia.setDate(vigencia.getDate() + 1);
    $scope.driver.vigencia = new Date($scope.driver.vigencia);
    //End vigencia
  });
  UsersService.getAllCity(function (response) {
    $scope.citys = response.data;
    console.log($scope.citys);
  });

  UsersService.getSucursal(id_entidad, function (response) {
    $scope.sucursales = response.data;
    console.log($scope.sucursales);
  });

  $scope.avaliable = function () {

    $scope.continueForm = true;
    console.log($scope.continueForm);
  };

  $scope.edit_driver = function (data) {

    data.empresa = id_entidad;

    console.warn(data);
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }UsersService.edit(fd, function (response) {
      Notification.success('Modificado correctamente');
      $location.path('/licencias');
    });
  };

  $scope.clear = function () {
    console.log('afsd');

    $scope.driver = {};

    angular.element("input[type='file']").val(null);
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
}]);
'use strict';

angular.module('app.users').controller('DetailCtrl', ['$scope', 'CONFIG', 'UsersService', '$routeParams', function ($scope, CONFIG, UsersService, $routeParams) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.user = $scope.$parent.user.user;
  var id_entidad = $scope.$parent.user.user.id_entidad;

  console.warn($routeParams.id);
  UsersService.get_one_driver($routeParams.id, function (response) {
    $scope.driver = response.data[0];
  });

  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };
  $scope.back_licenses = function () {

    $location.path('/licencias');
  };
  $scope.printImg = function () {
    print();
  };
}]);
"use strict";
'use strict';

angular.module('app.home', []).service('HomeService', ['$http', 'CONFIG', function ($http, CONFIG) {
  var url = CONFIG.API_URL;

  this.handleError = function (res) {
    console.warn(res);
  };

  this.sendRegisterPlate = function (data, callback) {
    var conf = {
      url: url + 'register-plate/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };
  this.getAll = function (id, callback, error, noblock) {

    return $http.get(url + 'license-plate/' + id).then(callback, error);
  };
  this.get_scraper = function (cedula, callback, error, noblock) {

    return $http.post('http://simmit.herokuapp.com/values', { 'cedula': cedula }).then(callback, error);
    // return $http.post('http://localhost:5000', {'cedula':cedula}).then(callback, error);
  };
  this.getCity = function (callback, error, noblock) {
    console.log('servicio ciudad');

    return $http.get(url + 'show-city/').then(callback, error);
  };
  this.getAllNotifications = function (id, callback, error, noblock) {
    console.warn('noti' + id);

    return $http.get(url + 'notification/' + id).then(callback, error);
  };

  this.getAllPlateAvaliable = function (id, callback, error, noblock) {

    return $http.get(url + 'list-plates-avaliable/' + id).then(callback, error);
  };

  this.checkExpire = function (plateDocu, callback, error) {
    return $http.post(url + 'check-document/', plateDocu).then(callback, error);
  };
  this.save_create_plate = function (plate, callback, error) {
    return $http.post(url + 'create-plate/', plate).then(callback, error);
  };
  this.update_plate = function (plate, callback, error) {
    return $http.post(url + 'update-plate/', plate).then(callback, error);
  };
  this.getAllDocuments = function (id, empresa, callback) {
    return $http.get(url + 'documentos/' + id + '/' + empresa).then(callback);
  };

  this.update = function (data, callback) {
    console.warn(data);
    var conf = {
      url: url + 'document-update/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };

  this.editDocument = function (data, success, error) {
    console.warn(data);
    var conf = {
      url: url + 'document-edit/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(success, error);
  };
  this.nullDocument = function (data, success, error) {
    console.warn(data);

    var conf = {
      url: url + 'document-null/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(success, error);
  };
  this.getVersions = function (id, id_placa, empresa, callback) {
    return $http.get(url + 'versions-documents/' + id + '/' + id_placa + '/' + empresa).then(callback);
  };
  this.getClaseVehiculo = function (callback, error, noblock) {
    console.log('servicio clase');

    return $http.get(url + 'mostrar_clase_automoviles/').then(callback, error);
  };
}]);
'use strict';

angular.module('app.home').controller('MainCtrl', ['$scope', '$rootScope', 'AUTH_EVENTS', 'Session', 'HomeService', 'Notification', function ($scope, $rootScope, AUTH_EVENTS, Session, HomeService, Notification) {
  // console.warn('main ctrl');

  $scope.user = null;
  $scope.expandedMenu = true;

  $scope.user_new = Session.getUser();
  if ($scope.user_new) {

    var idEntidad = $scope.user_new.user.id_entidad;
    HomeService.getAllNotifications(idEntidad, function (response) {
      $scope.notifications = response.data;
      $scope.counter = $scope.notifications.length;
      // console.warn($scope.counter);
      if ($scope.counter > 1) {
        Notification.success("Tiene  algunas Notificaciones");
      }
      if ($scope.counter == 1) {

        Notification.success("Tiene una Notificación");
      }
    });
  }

  $scope.$on('notifications', function (event, data) {
    $scope.counter = data;
  });

  $scope.setCurrentUser = function (user) {
    $scope.user = user;
  };
  $scope.changeCounterNotification = function (counter) {
    $scope.notifications.length = counter;
    // console.log('entro'+$scope.notifications.length);
  };

  $scope.logout = function (user) {
    $rootScope.$broadcast(AUTH_EVENTS.logout);
  };

  /* responsive menu */
  var screenSizes = $.AdminLTE.options.screenSizes;

  var miniSidebarHandler = function miniSidebarHandler() {
    //Enable hide menu when clicking on the content-wrapper on small screens
    if ($(window).width() <= screenSizes.sm - 1 && $("body").hasClass("sidebar-open")) {
      $("body").removeClass('sidebar-open');
    }
  };

  $(".content-wrapper").click(miniSidebarHandler);

  $scope.toggleMenu = function () {
    // console.warn('abrir');
    //Enable sidebar push menu
    if ($(window).width() > screenSizes.sm - 1) {
      if ($("body").hasClass('sidebar-collapse')) {
        $("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
      } else {
        $("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
      }
    }
    //Handle sidebar push menu for small screens
    else {
        if ($("body").hasClass('sidebar-open')) {
          $("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
        } else {
          $("body").addClass('sidebar-open').trigger('expanded.pushMenu');
        }
      }
  }; //end toggle
  $rootScope.$on('toggleMenu', function () {
    miniSidebarHandler();
  });

  //init
  $scope.setCurrentUser(Session.getUser());
}]);
'use strict';

angular.module('app.home').directive('t3bHeader', function () {
  return {
    scope: {},
    //bindToController: {
    //user: '='
    //},
    controller: ['$rootScope', '$scope', 'Session', function ($rootScope, $scope, Session) {
      var vm = this;

      vm.logout = $rootScope.logout;
      vm.loggedUser = $scope.$parent.user;

      /* responsive menu */
      var screenSizes = $.AdminLTE.options.screenSizes;

      var miniSidebarHandler = function miniSidebarHandler() {
        //Enable hide menu when clicking on the content-wrapper on small screens
        if ($(window).width() <= screenSizes.sm - 1 && $("body").hasClass("sidebar-open")) {
          $("body").removeClass('sidebar-open');
        }
      };

      $(".content-wrapper").click(miniSidebarHandler);

      vm.toggleMenu = function () {
        //Enable sidebar push menu
        if ($(window).width() > screenSizes.sm - 1) {
          if ($("body").hasClass('sidebar-collapse')) {
            $("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
          } else {
            $("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
          }
        }
        //Handle sidebar push menu for small screens
        else {
            if ($("body").hasClass('sidebar-open')) {
              $("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
            } else {
              $("body").addClass('sidebar-open').trigger('expanded.pushMenu');
            }
          }
      }; //end toggle
      $rootScope.$on('toggleMenu', function () {
        miniSidebarHandler();
      });
    }],
    controllerAs: 'ctrl',
    template: ' \n      <header class="main-header">\n        <!-- Logo -->\n        <a href="/" class="logo">\n          <!-- mini logo for sidebar mini 50x50 pixels -->\n          <span class="logo-mini"><b>TM</b></span>\n          <!-- logo for regular state and mobile devices -->\n         <!-- <span class="logo-lg"><b>Trasmovil</b> S.A.S</span>-->\n          <img src="/assets/img/trasmovil_logo.png" width="120px" class="user-image" alt="User Image">\n        </a>\n        <!-- Header Navbar: style can be found in header.less -->\n        <nav class="navbar navbar-static-top text-center" role="navigation">\n          <!-- Sidebar toggle button-->\n          <a href="javascript:void(0);" ng-click="ctrl.toggleMenu()" class="sidebar-toggle" data-toggle="offcanvas" role="button">\n            <span class="sr-only">Toggle navigation</span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n            <span class="icon-bar"></span>\n          </a>\n          <div class="navbar-custom-menu">\n            <ul class="nav navbar-nav">\n <li class="dropdown messages-menu">\n <a href="#" class="dropdown-toggle" data-toggle="dropdown">\n <i class="fa fa-bell-o fa-2x"></i>\n <span class="label label-danger">1</span>\n </a>\n <ul class="dropdown-menu">\n <li class="header">Tienes 1 documentos vencidos</li>\n <li>\n <!-- inner menu: contains the actual data -->\n <ul class="menu">\n <li><!-- start message -->\n <a href="#">\n <div class="pull-left">\n <img src="http://localhost:8000/image/documento.png" class="img-circle" alt="User Image">\n </div>\n <h4>\n SOAT\n <small><i class="fa fa-clock-o"></i> 5 mins</small>\n </h4>\n <p>Placa: TYT435</p>\n </a>\n </li><!-- end message -->\n ...\n </ul>\n </li>\n <li class="footer"><a href="#">Ver todos los mensajes</a></li>\n </ul>\n </li>\n\n                     <li class="dropdown user user-menu">\n                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">\n                  <img src="https://randomuser.me/api/portraits/men/21.jpg" class="user-image" alt="User Image">\n                  <span class="hidden-xs">{{ ctrl.loggedUser.user.nombre  }}</span>\n                </a>\n                <ul class="dropdown-menu">\n                  <!-- User image -->\n                  <li class="user-header">\n                    <img src="https://randomuser.me/api/portraits/men/21.jpg" class="img-circle" alt="User Image">\n                    <p>\n                      {{ ctrl.loggedUser.user.nombre +\' \'+ctrl.loggedUser.user.apellido }}\n                    </p>\n                    <p>\n                      {{ ctrl.loggedUser.user.email }}\n                    </p>\n                  </li>\n                  <!-- Menu Footer-->\n                  <li class="user-footer">\n                    <div class="pull-left">\n                      <a href="/perfil" class="btn btn-default btn-flat"><i class="fa fa-user"></i>  Mi información </a>\n                    </div>\n                    <div class="pull-right">\n                      <button ng-click="$rootScope.logout()" class="btn btn-default btn-flat">\n                        <i class="fa fa-sign-out"></i>Salir \n                      </button>\n                    </div>\n                  </li>\n                </ul>\n              </li>\n            </ul>\n          </div>\n        </nav>\n      </header>\n      '
  };
});
'use strict';

angular.module('app.home').controller('HomeCtrl', ['$scope', 'HomeService', 'UsersService', 'CONFIG', 'Notification', '$sce', '$interval', 'DTOptionsBuilder', 'DTColumnBuilder', function ($scope, HomeService, UsersService, CONFIG, Notification, $sce, $interval, DTOptionsBuilder, DTColumnBuilder) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  $scope.logo = null;
  $scope.plates = {};
  $scope.plate = {};
  $scope.image = [];
  $scope.edit = false;
  $scope.continueForm = false;
  $scope.button_renove = false;
  var fecha_docu_vencido = "";

  console.log("%cDesarrollado por TRASMOVIL S.A.S", "; color: red; font-size: x-large");
  $(".sel").select2();
  $scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(10).withLanguage({
    "sSearch": "Buscar",
    "sLengthMenu": "Mostrar _MENU_ entradas",
    "sEmptyTable": "No hay  documentos que mostrar",
    "sInfo": "Mostrando _START_ a  _END_ de  _TOTAL_ entradas",
    "sZeroRecords": "No se encontraron resultados",
    "oPaginate": {
      "sNext": "Siguiente",
      "sPrevious": "Anterior"
    }
  }).withOption('responsive', true).withButtons([{
    extend: 'copy',

    text: 'Copiar',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'print',
    text: 'Imprimir',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'excel',
    text: 'Exportar a Excel ',
    exportOptions: {
      columns: [0, 1]
    }
  }]);

  $scope.user = $scope.$parent.user.user;
  console.log($scope.user.directorioftp);

  var idEntidad = $scope.$parent.user.user.id_entidad;

  HomeService.getAllNotifications(idEntidad, function (response) {
    $scope.notifications = response.data;
    console.log($scope.notifications);

    $scope.$emit('notifications', $scope.counter);
  });

  HomeService.getAll(idEntidad, function (response) {
    console.log(response);
    $scope.plates = response.data;
  });

  $scope.search_notifications = function () {
    $("#search").keyup(function () {

      var valu = this;
      // Show only matching TR, hide rest of them
      $.each($(".box-solid"), function () {
        if ($(this).text().toLowerCase().indexOf($(valu).val().toLowerCase()) === -1) $(this).hide();else $(this).show();
      });
    });
  };
  // abre el modal de registro 
  $scope.openForm = function () {
    //$scope.continueForm = false; 


    HomeService.getAllPlateAvaliable(idEntidad, function (response) {

      $scope.platesAvaliable = response.data;
      console.warn($scope.platesAvaliable);
      $('#registerFormModal').modal('show');
    });
  };

  $scope.recoverPassword = function () {

    $('#recoverFormModal').modal('show');
  };
  //trae placa y documento
  $scope.docuPlate = function () {

    console.log($scope.plate.idm_movil_extern);
    console.log($scope.plate.tipoDocumento);

    if ($scope.plate.idm_movil_extern == undefined || $scope.plate.tipoDocument == undefined) {
      return;
    };

    var docuPlateCheck = { "idm_movil_extern": $scope.plate.idm_movil_extern, "tipo_document": $scope.plate.tipoDocument };

    console.log(docuPlateCheck);

    HomeService.checkExpire(docuPlateCheck, function (response) {

      var res = response.data.error;

      var re = response.data;
      console.warn(docuPlateCheck);
      if (!$.trim(re)) {
        $scope.continueForm = true;
        return;
      } else {

        $scope.continueForm = false;
        Notification.error({ message: res, positionX: 'center' });
      };
    });
  };
  //
  //registra el documento la placa
  $scope.saveRegister = function (data) {

    /* let r = confirm("Estas seguro que quiere registrar esta placa  con  "+data.fecha_vence+ "?");
        if(r != true){
         return; 
        };*/

    $scope.continueForm = false;
    data.empresa = idEntidad;

    console.log(data);
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.sendRegisterPlate(fd, function (response) {

      Notification.success('Registrado correctamente');

      $scope.plate = {};
      angular.element("input[type='file']").val(null);

      $scope.continueForm = false;
    });
  };

  //trae formulario de renovacion
  $scope.openFormRenove = function (documentRenove, documentoTipo) {
    $scope.documentoTipo = documentoTipo;
    $scope.fecha_vencimiento = documentRenove.fecha_vence;

    $scope.documento = angular.copy(documentRenove);

    $scope.documento.entidad = "";

    $scope.documento.no_doc = "";
    console.log($scope.documento);

    angular.element("input[type='file']").val(null);

    $scope.button_renove = false;

    var date_add = new Date(documentRenove.fecha_vence);
    $scope.documento.fecha_vencido = new Date(date_add.setDate(date_add.getDate() + 1));
    $scope.documento.fecha_vence_copy = angular.copy($scope.documento.fecha_vencido);

    fecha_docu_vencido = $scope.documento.fecha_vence;

    $('#renoveFormModal').modal('show');
  };

  //compara la fecha actual con la nueva
  $scope.compareDate = function () {

    var fecha = $scope.documento.fecha_vence_copy;

    var fechaActual = new Date(fecha).getTime();
    var fechaNueva = new Date($scope.documento.fecha_vencido).getTime();

    console.log(fechaActual + ',' + fechaNueva);

    if (fechaActual >= fechaNueva) {

      $scope.button_renove = false;
      Notification.error('La fecha que intentas ingresar debe  mayor  a la actual');
    } else {

      $scope.button_renove = true;
    };
  };

  //trae documentos de la placa
  $scope.openFormDocument = function ($index, placa) {
    $scope.placa_documento = placa;

    HomeService.getAllDocuments($index, idEntidad, function (response) {
      $scope.documents = response.data;

      console.log($scope.documents);

      $('#documentFormModal').modal('show');
    });
  };

  //muestra imagen del documento
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };

  $scope.editing = function (id) {

    $scope.edit = true;
    $scope.cod = id;
  };

  $scope.cancel = function () {

    $scope.edit = false;
    $scope.cod = "p";
  };

  //actualiza documento
  $scope.update = function (data) {
    console.log(data);

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      $scope.documento.fecha_vence = new Date(date_modify.setDate(date_modify.getDate() + 1));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    $scope.button_renove = false;

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.update(fd, function (response) {
      console.log(response);
      $scope.documents = response.data;

      Notification.success('Actualizado  correctamente');

      $('#renoveFormModal').modal('hide');

      HomeService.getAllNotifications(idEntidad, function (response) {
        $scope.notifications = response.data;

        $scope.counter = $scope.notifications.length;

        $scope.$emit('notifications', $scope.counter);
      });
    });
  };

  $scope.editDoc = function (data) {
    console.log(data);

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      //     $scope.documento.fecha_vence =  new Date(date_modify.setDate(date_modify.getDate()+ 1 ));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.editDocument(fd, function (response) {

      $scope.documents = response.data;
      Notification.success('Actualizado  correctamente');

      $('#renoveFormModal').modal('hide');
    });
  };
  $scope.nullDoc = function (data) {
    console.log(data);

    var r = confirm("Una vez anulado no podrá modificar  esto. ¿Estas seguro que desea anular este documento?");

    if (r != true) {

      return;
    };

    if (data.fecha_vencido != undefined) {
      var date_modify = data.fecha_vencido;
      var date = new Date(date_modify.setDate(date_modify.getDate() - 1));
      //     $scope.documento.fecha_vence =  new Date(date_modify.setDate(date_modify.getDate()+ 1 ));
      data.fecha_vence = date;
    }

    console.warn(data);

    $scope.edit = false;
    $scope.cod = "p";

    var fd = new FormData();

    for (var key in data) {
      fd.append(key, data[key]);
    }HomeService.nullDocument(fd, function (response) {

      $scope.documents = response.data;
      Notification('Anulado  correctamente');

      $('#renoveFormModal').modal('hide');
    });
  };
  $scope.clear = function () {
    $scope.plate = {};

    angular.element("input[type='file']").val(null);
  };
  $scope.versions = function (id, id_placa) {
    console.log(id);

    HomeService.getVersions(id, id_placa, idEntidad, function (response) {
      console.log(response.data);
      $scope.previus_documents = response.data;
      console.log();

      $('#versionsDocumentsModal').modal('show');
    });
  };

  $scope.form_create = function () {
    var id_entidad = $scope.$parent.user.user.id_entidad;
    UsersService.getSucursal(id_entidad, function (response) {
      $scope.sucursales = response.data;
      console.log($scope.sucursales);
    });
    HomeService.getCity(function (response) {
      $scope.citys = response.data;
      console.log($scope.citys);
    });
    HomeService.getClaseVehiculo(function (response) {
      $scope.clase_vehiculos = response.data;
      console.warn($scope.clase_vehiculos);
    });

    $scope.plate = {};
    $('#createFormModal').modal('show');
  };

  $scope.create_save_plate = function (plate) {
    plate.id_entidad = $scope.$parent.user.user.id_entidad;
    console.log(plate);

    HomeService.save_create_plate(plate, function (response) {
      var res = response.data.error;

      var re = response.data;
      if (res) {

        $scope.continueForm = false;
        Notification.error({ message: res, positionX: 'center' });
      } else {
        $scope.continueForm = true;
        HomeService.getAll(idEntidad, function (response) {
          console.log(response);
          $scope.plates = response.data;
        });
        $scope.plate = {};

        Notification.success('Actualizado  correctamente');
        return;
      };
      console.log(response.data);
    });
  };
  $scope.openFormEditPlate = function (plate) {
    console.log(plate);
    $scope.plate = angular.copy(plate);
    var fecha_matricula = new Date($scope.plate.fecha_matricula);
    $scope.plate.fecha_matricula = fecha_matricula.setDate(fecha_matricula.getDate() + 1);
    $scope.plate.fecha_matricula = new Date($scope.plate.fecha_matricula);
    var id_entidad = $scope.$parent.user.user.id_entidad;
    UsersService.getSucursal(id_entidad, function (response) {
      $scope.sucursales = response.data;
      console.log($scope.sucursales);
    });
    HomeService.getCity(function (response) {
      $scope.citys = response.data;
      console.log($scope.citys);
    });

    $('#editFormModal').modal('show');
  };
  $scope.edit_plate = function (plate) {
    HomeService.update_plate(plate, function (response) {
      $scope.plate = {};
      HomeService.getAll(idEntidad, function (response) {
        console.log(response);
        $scope.plates = response.data;
      });
      $('#editFormModal').modal('hide');

      Notification.success('Actualizado  correctamente');
    });
  };
  $scope.printImg = function () {
    print();
  };
}]).directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      elem.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, elem[0].files[0]);
        });
      });
    }
  };
}]).directive('tooltip', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      $(element).hover(function () {
        // on mouseenter
        $(element).tooltip('show');
      }, function () {
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
}).filter('makePositive', function () {
  return function (num) {
    return Math.abs(num);
  };
});
'use strict';

angular.module('app.migrate', []).service('MigrateService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.url = CONFIG.API_URL;
  this.currentUser = null;

  this.getAll = function (callback) {
    return $http.get(this.url + 'empresas/').then(callback);
  };
  this.sendEmpresa = function (id, callback, error, noblock) {
    console.log(id);

    return $http.get(this.url + 'empresa/uw212uisdajasd/' + id).then(callback, error);
  };
}]);
'use strict';

angular.module('app.migrate').controller('MigrateCtrl', ['$scope', 'Notification', 'CONFIG', 'MigrateService', 'UsersService', '$location', function ($scope, Notification, CONFIG, MigrateService, UsersService, $location) {
  $scope.baseUrl = CONFIG.PUBLIC_URL;

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.user = $scope.$parent.user.user;
  MigrateService.getAll(function (response) {
    $scope.empresas = response.data;
    console.log($scope.empresas);

    // body...
  });

  $scope.sendId = function (idEmpresa, nombre, bd) {

    console.log(nombre);
    var r = confirm("Esta seguro que desea migrar esta base de datos " + bd + " de la empresa " + nombre + " ?");
    var res = "la base de datos " + bd + " de la empresa " + nombre + " ha sido migrada correctamente";

    if (r != true) {

      return;
    };
    MigrateService.sendEmpresa(idEmpresa, function (response) {

      $scope.empresas = response.data;
      // body...
      Notification.success({ message: res, positionX: 'center' });
    });
  };
}]);
'use strict';

angular.module('app.days_vigence', []).controller('FormCtrl', ['$scope', 'FormService', 'HomeService', 'CONFIG', '$routeParams', 'DTOptionsBuilder', 'DTColumnBuilder', 'Notification', function ($scope, FormService, HomeService, CONFIG, $routeParams, DTOptionsBuilder, DTColumnBuilder, Notification) {
  $scope.continueForm = true;

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;
  var id_entidad = $scope.$parent.user.user.id_entidad;
  console.log(id_entidad);

  console.log("%cDesarrollado por TRASMOVIL S.A.S", "; color: red; font-size: x-large");
  $scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(10).withLanguage({
    "sSearch": "Buscar",
    "sLengthMenu": "Mostrar _MENU_ entradas",
    "sEmptyTable": "No hay  documentos que mostrar",
    "sInfo": "Mostrando _START_ a  _END_ de  _TOTAL_ entradas",
    "sZeroRecords": "No se encontraron resultados",
    "oPaginate": {
      "sNext": "Siguiente",
      "sPrevious": "Anterior"
    }
  }).withOption('responsive', true);

  $scope.documents = {};

  $scope.user = $scope.$parent.user.user;

  FormService.show_days(id_entidad, function (response) {
    $scope.documents_days = response.data;
  });

  $scope.save_form_days = function (days) {
    console.log(days);
    // console.warn($scope.$parent.user.user.id_entidad);
    days.id_entidad = $scope.$parent.user.user.id_entidad;

    FormService.days_vigence(days, function (response) {
      $scope.documents_days = response.data;
      HomeService.getAllNotifications(id_entidad, function (response) {
        $scope.notifications = response.data;

        $scope.counter = $scope.notifications.length;
        $scope.$emit('notifications', $scope.counter);

        if ($scope.counter > 1) {
          Notification.success("Tiene  algunas Notificaciones");
        }
        if ($scope.counter == 1) {

          Notification.success("Tiene una Notificación");
        }
      });
    });
  };
}]);
'use strict';

angular.module('app.days_vigence').service('FormService', ['$http', 'CONFIG', function ($http, CONFIG) {
   this.url = CONFIG.API_URL;
   this.currentUser = null;

   this.days_vigence = function (data, callback, error) {
      return $http.post(this.url + 'insert_days/', data).then(callback, error);
   };

   this.show_days = function (id, callback, error) {
      return $http.get(this.url + 'show_days_documents/' + id).then(callback, error);
   };
}]);
'use strict';

angular.module('app.auth', []).service('Session', [function () {

  this.token = null;
  this.user = null;

  //create session from local storage
  this._createLc = function (token, user) {
    window.localStorage.setItem('token', angular.toJson(token));
    window.localStorage.setItem('user', angular.toJson(user));
  };

  //destroy session from local storage 
  this._destroyLc = function () {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
  };

  //create session from memory 
  this.create = function (token, user) {
    this.token = token;
    this.user = user;
    this._createLc(token, user);
  };

  //destroy session from memory 
  this.destroy = function () {
    this.token = null;
    this.user = null;
    this._destroyLc();
  };

  //get token from memory or localStorage
  this.getToken = function () {
    var token = this.token;
    if (!token) {
      token = angular.fromJson(window.localStorage.getItem('token'));
    }
    return token;
  };

  //get user from memory or localStorage
  this.getUser = function () {
    var user = this.user;
    if (!user) {
      user = angular.fromJson(window.localStorage.getItem('user'));
    }
    return user;
  };

  this.isAuthenticated = function () {
    return this.getToken() != null;
  };
}]);
'use strict';

angular.module('app.auth').factory('AuthInterceptor', ['$rootScope', '$q', 'AUTH_EVENTS', 'Session', function ($rootScope, $q, AUTH_EVENTS, Session) {
  return {
    // poner el token en cada request
    request: function request(config) {
      var token = Session.getToken();
      if (token) {
        config.headers.Authorization = 'Token ' + token;
      }
      return config;
    },
    responseError: function responseError(response) {
      console.log("entro por interceptor de error");
      $rootScope.$broadcast({
        401: AUTH_EVENTS.notAuthenticated,
        403: AUTH_EVENTS.notAuthorized
      }[response.status], response);
      console.log(response);
      return $q.reject(response);
    }
  };
}]);
'use strict';

angular.module('app.auth').service('LoginService', ['$http', 'CONFIG', 'Session', function ($http, CONFIG, Session) {
  var url = CONFIG.API_URL + 'auth/';

  this.handleError = function (res) {
    console.warn(res);
  };

  /*
   *api token request
   */
  this.requestToken = function (data, callback, error) {
    return $http.post(url + 'login', data).then(callback, error);
  };

  /*
   *login, create a session
   */
  this.login = function (token, callback) {
    var config = {
      method: 'GET',
      url: CONFIG.API_URL + 'users/me/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Bearer ' + token
      }
    };

    return $http(config).then(function (response) {
      console.log(response.data);
      Session.create(token, response.data);
      callback(response);
    }, this.handleError);
  };
}]);
'use strict';

angular.module('app.auth').controller('LoginCtrl', ['$scope', 'LoginService', '$location', function ($scope, LoginService, $location) {

  $scope.user = {};
  $scope.busy = false;

  /* handle success login */
  var successLogin = function successLogin(response) {
    //get user data, create a session and redirect to home
    LoginService.login(response.data.token, function (response) {
      console.warn(response);
      $scope.setCurrentUser(response.data);
      $scope.busy = false;
      $location.path('/');
    });
  };

  /* handle errors on login */
  var errorLogin = function errorLogin(response) {
    $scope.busy = false;
    // $scope.errors = response.data.non_field_errors;
    $scope.errors = [response.data.error];
    console.log(response);
  };

  /* fired when the user click to "Entrar" */
  $scope.login = function () {
    console.warn($scope.user);
    $scope.busy = true;
    LoginService.requestToken($scope.user, successLogin, errorLogin);
  };
  $scope.recoverPassword = function () {
    $('#recoverFormModal').modal('show');
  };
}]);
'use strict';

angular.module('app.contracts', []).controller('ContractCtrl', ['$scope', 'Notification', 'CONFIG', 'ContractService', 'UsersService', '$location', 'DTOptionsBuilder', 'DTColumnBuilder', function ($scope, Notification, CONFIG, ContractService, UsersService, $location, DTOptionsBuilder, DTColumnBuilder) {

  $scope.baseUrl = $scope.$parent.user.user.directorioftp;
  $scope.baseUrlLocal = CONFIG.PUBLIC_URL_SERVER_LOCAL;

  $scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(10).withLanguage({
    "sSearch": "Buscar",
    "sLengthMenu": "Mostrar _MENU_ entradas",
    "sEmptyTable": "No hay  documentos que mostrar",
    "sInfo": "Mostrando _START_ a  _END_ de  _TOTAL_ entradas",
    "sZeroRecords": "No se encontraron resultados",
    "oPaginate": {
      "sNext": "Siguiente",
      "sPrevious": "Anterior"
    }
  }).withOption('responsive', true).withButtons([{
    extend: 'copy',

    text: 'Copiar',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'print',
    text: 'Imprimir',
    exportOptions: {
      columns: [0, 1]
    }
  }, {
    extend: 'excel',
    text: 'Exportar a Excel ',
    exportOptions: {
      columns: [0, 1]
    }
  }]);

  ContractService.getCiudad(function (response) {
    $scope.municipios = response.data;
    console.log($scope.municipio);
  });
  // console.log("%cHola que mas, no hay nada que buscar por aqui", "background: green; color: black; font-size: x-large");
  console.log("%cDesarrollado por TRASMOVIL S.A.S", "; color: red; font-size: x-large");

  var idEntidad = $scope.$parent.user.user.id_entidad;
  $scope.user = $scope.$parent.user.user;
  ContractService.getAll(idEntidad, function (response) {
    $scope.contratos = response.data;
    console.log($scope.contratos);
  });
  $scope.detallesContrato = function (contrato) {
    console.log(contrato);

    $scope.contrato = angular.copy(contrato);

    // let inicial = new Date($scope.contrato.fecha_inicial);
    //       $scope.contrato.fecha_inicial = inicial.setDate(inicial.getDate() + 1);
    //       $scope.contrato.fecha_inicial = new Date($scope.contrato.fecha_inicial);
    //       // console.log($scope.contrato.fecha_inicial);
    //       //Fecha final
    //       let fecha_final = new Date($scope.contrato.fecha_final);
    //       $scope.contrato.fecha_final = fecha_final.setDate(fecha_final.getDate() + 1);
    //       $scope.contrato.fecha_final = new Date($scope.contrato.fecha_final);
    //        let fecha_final_adendo = new Date($scope.contrato.fecha_final_adendo);
    //       $scope.contrato.fecha_final_adendo = fecha_final.setDate(fecha_final_adendo.getDate() + 1);
    //       $scope.contrato.fecha_final_adendo = new Date($scope.contrato.fecha_final_adendo);


    $('#detallesContrato').modal('show');
  };
  $scope.openImage = function (imagen) {
    console.log('entro');
    $scope.imageFull = imagen;
    $('#imageFull').modal('show');
  };

  $scope.editarContrato = function (id) {

    var idEntidad = $scope.$parent.user.user.id_entidad;
    // $location.path('/edit-contrato/'+id);
    ContractService.getEdit(id, idEntidad, function (response) {
      // body...

      $scope.contrato = response.data[0];
      console.log($scope.contrato);
      //Fecha de inicial
      var inicial = new Date($scope.contrato.fecha_inicial);
      $scope.contrato.fecha_inicial = inicial.setDate(inicial.getDate() + 1);
      $scope.contrato.fecha_inicial = new Date($scope.contrato.fecha_inicial);
      // console.log($scope.contrato.fecha_inicial);
      //Fecha final
      var fecha_final = new Date($scope.contrato.fecha_final);
      $scope.contrato.fecha_final = fecha_final.setDate(fecha_final.getDate() + 1);
      $scope.contrato.fecha_final = new Date($scope.contrato.fecha_final);
      var fecha_final_adendo = new Date($scope.contrato.fecha_final_adendo);
      $scope.contrato.fecha_final_adendo = fecha_final.setDate(fecha_final_adendo.getDate() + 1);
      $scope.contrato.fecha_final_adendo = new Date($scope.contrato.fecha_final_adendo);
    });

    // ContractService.getCiudad(function(response){
    //       $scope.municipios = response.data;
    //       console.log($scope.municipio);
    //     });

    $('#editarContrato').modal('show');

    // $scope.contrato.descripcion_munic = "";

  };

  $scope.sendEdit = function (data) {

    console.log(data);

    data.empresa = $scope.$parent.user.user.id_entidad;;

    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }ContractService.sendEdit(fd, function (response) {

      Notification.success('Contrato modificado exitosamente');

      $('#editarContrato').modal('hide');

      ContractService.getAll(idEntidad, function (response) {
        $scope.contratos = response.data;
        console.log($scope.contratos);
      });

      angular.element("input[type='file']").val(null);
      $scope.contrato = {};
    });
  };
  $scope.formCreateContract = function () {
    $scope.contrato = {};

    $('#crearContrato').modal('show');

    // ContractService.getCiudad(function(response){
    //   $scope.municipios = response.data;
    //   console.log($scope.municipio);
    // });
  };
  $scope.formUpdateContract = function (Contrato) {

    $scope.contrato = angular.copy(Contrato);
    $scope.contrato.no_cto_externo = '';
    $scope.contrato.fecha_inicial = '';
    $scope.contrato.fecha_final = '';
    $scope.contrato.fecha_final_adendo = '';
    $scope.contrato.descripcion = '';
    $scope.contrato.no_adendo = '';
    $scope.contrato.sub_contratante = '';
    $scope.contrato.clase_vehicular = '';

    $('#actualizarContrato').modal('show');
  };
  $scope.crearContrato = function (data) {

    data.empresa = $scope.$parent.user.user.id_entidad;;
    data.idm_usuario = $scope.$parent.user.user.idm_usuarios;
    console.log(data);

    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }ContractService.create(fd, function (response) {

      Notification.success('Contrato creado exitosamente');

      $('#editarContrato').modal('hide');
    });
  };
  $scope.anularContrato = function (id, idz, empresa, contrato) {

    console.log(id);
    console.log(contrato);
    console.log(idz);
    console.log(empresa);

    var r = confirm("Una vez anulado no podrá modificar  esto. ¿Estas seguro que desea anular este contrato?");

    if (r != true) {

      return;
    };
    ContractService.anular(id, idz, empresa, function (response) {
      $scope.contratos = response.data;
      console.log($scope.contratos);

      Notification.success('Contrato creado exitosamente');

      $('#actualizarContrato').modal('hide');
    });
  };
  $scope.actualizarContrato = function (data) {

    data.empresa = $scope.$parent.user.user.id_entidad;;
    console.log(data);

    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }ContractService.update(fd, function (response) {

      Notification.success('Contrato actualizado exitosamente');

      $('#actualizarContrato').modal('hide');
    });
  };

  $scope.clear = function (contrato) {

    $scope.contrato = {};

    angular.element("input[type='file']").val(null);

    $('#editarContrato').modal('hide');
  };
  $scope.printImg = function () {
    print();
  };
}]);
'use strict';

angular.module('app.contracts').service('ContractService', ['$http', 'CONFIG', function ($http, CONFIG) {
  this.url = CONFIG.API_URL;
  this.currentUser = null;

  this.getAll = function (id, callback) {
    return $http.get(this.url + 'contratos/' + id).then(callback);
  };
  this.getEdit = function (id, empresa, callback) {

    return $http.get(this.url + 'contrato/' + id + '/' + empresa).then(callback);
  };
  this.getCiudad = function (callback) {

    return $http.get(this.url + 'ciudades/').then(callback);
  };
  this.sendOneContract = function (idContrato, callback) {

    return $http.get(this.url + 'recibir-contrato/' + idContrato).then(callback);
  };
  this.anular = function (idContrato, idz, empresa, callback) {

    return $http.get(this.url + 'anular-contrato/' + idContrato + '/' + idz + '/' + empresa).then(callback);
  };
  this.sendEdit = function (data, callback) {

    var conf = {
      url: this.url + 'editar-contrato/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };

  this.create = function (data, callback) {

    var conf = {
      url: this.url + 'crear-contrato/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };
  this.update = function (data, callback) {

    var conf = {
      url: this.url + 'actualizar-contrato/',
      data: data,
      method: 'POST',
      transformRequest: angular.identity,
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': undefined
      }
    };
    return $http(conf).then(callback);
  };
}]);
'use strict';

angular.module('app', ['ngRoute', 'templates', 'app.helpers', 'datatables', 'datatables.buttons', 'angular-loading-bar', 'ui.bootstrap', 'ui-notification', 'ngSanitize', 'ui.select', 'xeditable', 'app.auth', 'app.home', 'app.days_vigence', 'app.subpoena', 'app.users', 'app.contracts', 'app.statistics', 'app.migrate', 'ngSanitize']);
'use strict';

angular.module('app').run(['$rootScope', 'AUTH_EVENTS', 'Session', '$location', 'editableOptions', 'editableThemes', function ($rootScope, AUTH_EVENTS, Session, $location, editableOptions, editableThemes) {
  editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
  editableThemes['bs3'].submitTpl = '<button class="btn btn-flat btn-primary" type="submit">' + '<i class="fa fa-check"></i></button>';

  editableThemes['bs3'].cancelTpl = '<button class="btn btn-flat btn-default" ng-click="$form.$cancel()">' + '<i class="fa fa-times"></i></button>';

  function logout() {
    Session.destroy();
    $location.path('/login');
  }

  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    logout();
    console.info('se activo interceptor not authenticated');
  });

  $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
    logout();
    console.info('se activo interceptor not authorized');
  });

  $rootScope.$on(AUTH_EVENTS.logout, function () {
    logout();
    console.info('se cerrara la sesion');
  });

  $rootScope.$on('$routeChangeStart', function (event, next) {
    if ($location.path() !== '/login') {
      if (!Session.isAuthenticated()) {
        logout();
      }
    }
  });
  $rootScope.logout = function () {
    logout();
  };

  $rootScope.goTo = function (url) {
    $location.path(url);
  };
}]);
'use strict';

/*
 * url routes
 */

angular.module('app').config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
  'use strict';

  $routeProvider.when("/login", {
    controller: "LoginCtrl",
    templateUrl: "app/auth/login.html"
  }).when("/", {
    controller: "GraficCtrl",
    templateUrl: "app/statistics/estatistics.html"
  }).when("/home", {
    controller: "HomeCtrl",
    templateUrl: "app/home/home.html"
  }).when("/migraciones", {

    controller: "MigrateCtrl",
    templateUrl: "app/migrate/migrate.html"
  }).when("/licencias", {

    controller: "UsersCtrl",
    templateUrl: "app/users/users.html"
  }).when("/new", {
    controller: "NewCtrl",
    templateUrl: "app/users/users-new.html"
  }).when("/edit/:id", {
    controller: "EditCtrl",
    templateUrl: "app/users/users-edit.html"
  }).when("/renove/:id", {
    controller: "RenoveCtrl",
    templateUrl: "app/users/users-renove.html"
  }).when("/detail/:id", {
    controller: "DetailCtrl",
    templateUrl: "app/users/users-detail.html"
  }).when("/notificaciones", {
    controller: "HomeCtrl",
    templateUrl: "app/notifications/notifications.html"
  }).when("/days_vigence", {
    controller: "FormCtrl",
    templateUrl: "app/days_vigence/days_vigence.html"
  }).when("/contratos", {
    controller: "ContractCtrl",
    templateUrl: "app/contracts/contracts.html"
  })
  //   .when("/edit-contrato/:id", {
  //   controller: "ContractCtrl",
  //   templateUrl: "app/contracts/contrato-detail.html"
  // })
  .when("/comparendos", {
    controller: "SubpoenaCtrl",
    templateUrl: "app/subpoena/subpoena.html"
  }).otherwise({
    redirectTo: '/'
  });
  $locationProvider.html5Mode(true);
}]);
"use strict";

var _angular$module$const;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module("app").constant("CONFIG", (_angular$module$const = {
  ROOT_UR: "http://laraveltmovil.coviayturs.com/",
  //  API_URL: "http://betadesarrollo.cotracol.com/index.php/api/v1/",
  API_URL: "http://localhost:8000/api/v1/"
}, _defineProperty(_angular$module$const, "API_URL", "http://localhost:8000/api/v1/"), _defineProperty(_angular$module$const, "PUBLIC_URL", "http://fdn-static.bimaps.cloud-alls.trasmovil.co"), _defineProperty(_angular$module$const, "PUBLIC_URL_SERVER_LOCAL", "http://laraveltmovil.coviayturs.com/"), _angular$module$const)).constant("AUTH_EVENTS", {
  notAuthenticated: "auth-not-authenticated",
  notAuthorized: "auth-not-authorized",
  logout: "auth-logout"
});
'use strict';

angular.module('app').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push(['$injector', function ($injector) {
    return $injector.get('AuthInterceptor');
  }]);
}]).config(['NotificationProvider', function (NotificationProvider) {
  NotificationProvider.setOptions({
    delay: 2000,
    startTop: 60,
    startRight: 10,
    verticalSpacing: 20,
    horizontalSpacing: 20,
    positionX: 'right',
    positionY: 'top'
  });
}]);